import './App.css';
import { useState } from 'react';

function App() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // 'submitting', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const response = await fetch('https://formspree.io/f/xblpnplv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email })
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="App">
      <header className="hero">
        <h1>GulfLuxe</h1>
        <p className="tagline">Luxury stays curated for executives who value their time</p>
        
        <div className="featured-properties">
          <p className="label">LAUNCHING WITH</p>
          <div className="properties">
            <span>Taj Exotica Resort & Spa, Palm Jumeirah</span>
            <span>Anantara The Palm Dubai Resort</span>
            <span>Emirates Palace Mandarin Oriental</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="email-capture">
          <input 
            type="email" 
            placeholder="Enter your email for exclusive early access"
            className="email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={status === 'submitting'}
          />
          <button 
            type="submit" 
            className="notify-btn"
            disabled={status === 'submitting'}
          >
            {status === 'submitting' ? 'Sending...' : 'Notify Me'}
          </button>
        </form>

        {status === 'success' && (
          <p className="status-message success">Thank you! We'll notify you at launch.</p>
        )}
        {status === 'error' && (
          <p className="status-message error">Something went wrong. Please try again.</p>
        )}

        <p className="coming-soon">Launching January 2026</p>
      </header>
    </div>
  );
}

export default App;